document.addEventListener('DOMContentLoaded', function() {
    const elem = '<div id="banner-close"><svg aria-label="Dismiss" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" style="height: 1em; width: 1em;"><path d="M11.414 10l6.293-6.293a.999.999 0 1 0-1.414-1.414L10 8.586 3.707 2.293a.999.999 0 1 0-1.414 1.414L8.586 10l-6.293 6.293a.999.999 0 1 0 1.414 1.414L10 11.414l6.293 6.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z" fill="#333333"></path></svg></div>';
    const bannerInterval = setInterval(timer, 500);
    const count = 30;
    let index = 0;

    function timer() {
         
        const banner = document.getElementById('FreeShippingBanner');

        if (banner) {
            banner.insertAdjacentHTML('beforeend', elem);
            document.getElementById('banner-close').addEventListener('click', closeBanner);
            clearInterval(bannerInterval);
        }

        index++;
        if (index === count) {
            clearInterval(bannerInterval);
        }
    }

    function closeBanner() {
        document.getElementById('FreeShippingBanner').style.display = "none";
    }
})